import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CredentialsService } from './auth/credentials.service';

export const rootRedirectGuard: CanActivateFn = (route, state) => {
    const credentialsService = inject(CredentialsService);
    const router = inject(Router);

    if (credentialsService.isAuthenticated()) {
        router.navigate(['/home']);
        return false;
    } else {
        router.navigate(['/auth/login']);
        return false;
    }
};
